// A SKILL.md file conventionally opens with YAML frontmatter carrying its own
// name/description (the same metadata Anthropic's skill format uses for
// discovery) — pull just that line out rather than parsing the whole thing.
export function extractSkillDescription(content: string): string | null {
  const frontmatter = content.match(/^---\s*\n([\s\S]*?)\n---/);
  if (!frontmatter) return null;
  const desc = frontmatter[1].match(/^description:\s*(.+)$/m);
  return desc ? desc[1].trim() : null;
}
